import './LoadingBar.css'; // Make sure to create this CSS file

export default function LoadingBar() {
  return (
    <div className="loading-container">
      Loading...
      <div className="loading-bar"></div>
    </div>
  );
};